/**
 * Application Entry Point
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initializeAppInsights } from './services/appInsightsService'
import './style.css'

// Initialize Application Insights (before app mount for early error capture)
initializeAppInsights(router)

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(router)

// Mount app
app.mount('#app')
